import React from "react";

const FooterComponent = () => {
  return (
    <>
      <div className="footer-container w-100">
        <div className="container">
          <div className="row w-100">
            <div className="col-md-4">
              <div className="d-flex logo-header-container">
                <p className="logo-p">
                  FST
                  <span className="logo-p-details">design deliver empower</span>
                </p>
              </div>
              <p className="text-white">
                We will help you to monitor your various sources of energy consumptions.
              </p>
            </div>
            <div className="col-md-4">
              <p className="quick-link-heading"> Quick Links</p>
              <div>
                <div className="d-flex align-items-center justify-content-start pb-2">
                  <div className="quick-link-unorder-list-arrow" />
                  <p className="quick-link-unorder-list-p">PRODUCTS & SERVICES</p>
                </div>
                <div className="quick-link-divider" />
                <div className="d-flex align-items-center justify-content-start">
                  <div className="quick-link-unorder-list-arrow" />
                  <p className="quick-link-unorder-list-p">BUSINESS ENQUIRIES</p>
                </div>
                <div className="quick-link-divider" />
                <div className="d-flex align-items-center justify-content-start">
                  <div className="quick-link-unorder-list-arrow" />
                  <p className="quick-link-unorder-list-p">HELP</p>
                </div>
                <div className="quick-link-divider" />
                <div className="d-flex align-items-center justify-content-start">
                  <div className="quick-link-unorder-list-arrow" />
                  <p className="quick-link-unorder-list-p">CONTACTS</p>
                </div>
              </div>
            </div>
            <div className="col-md-4" />
          </div>
        </div>
      </div>
      <div className="copyright-container w-100">
        <p className="copyright-p">© 2022 Front End Solar Technologies. ALL RIGHTS RESERVED.</p>
      </div>
    </>
  );
};

export default FooterComponent;
